export function getAbweichung({
  baseValue,
  comparisonValue,
}: {
  baseValue: number;
  comparisonValue: number;
}) {
  let abweichung = 0;
  let isAbweichungNegative = false;
  abweichung = baseValue - comparisonValue;
  isAbweichungNegative = abweichung <= 0;
  // Es kann passieren, dass die Abweichung z.B. 1,77777778 beträgt
  // Um das korrekt anzuzeigen, wird hier die Abweichung auf 2 Nachkommastellen gerundet
  abweichung = Math.round((abweichung + Number.EPSILON) * 100) / 100;
  // Hiermit stellen wir sicher, dass die Abweichung nicht negativ dargestellt wird
  abweichung = Math.abs(abweichung);

  const prozentualeAbweichung = (abweichung * 100) / baseValue;

  return {
    abweichung,
    prozentualeAbweichung,
    isNegative: isAbweichungNegative,
  };
}
